<template>
   <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '展后新闻报道')[0].value">
    <div  style="margin-top: 3%;display: flex;  width: 90%;height: 75%; justify-content: flex-start;
    flex-wrap: wrap;">
      <el-card  class="mediaitem"
          v-for="(o, i) in AllNewsCoverage"
          :key="i">
        <el-tooltip :content="o.name"
                    placement="bottom"
                    effect="light">
          <img :src="Global.imgip+o.icon"
              class="hand"
              @click="Details(o)" />
        </el-tooltip>
      </el-card>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      flowID: localStorage.getItem("flowID"),
      caseID: localStorage.getItem("caseId"),
      AllNewsCoverage: [],
      NewsCoverageview: false,
      SModelNewsCoverageList: [],
      NewsCoverageform: {},
      isdisabled: false,
      NewsCoverageForm: {},
      title: '展后新闻报道',
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  mounted () {
    this.GetAllNewsCoverage();
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/MiceMarketing")
    },
    GetAllNewsCoverage () {
      this.$http.get("NewsCoverage/GetAllNewsCoverage?caseID=" + this.caseID).then((res) => {
        if (res.success) {
          this.AllNewsCoverage = res.dynamicObj;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    Details (NewsCoverageform) {
      // this.$emit("NewsCoverageform",NewsCoverageform)
      this.$router.push({path:'NewsCoverageEditCard',query:{ id : NewsCoverageform.id }})
    },
    GetSModelNewsCoverage () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_NewsCoverage"
        )
        .then((res) => {
          if (res.success) {
            this.SModelNewsCoverageList = res.dynamicObj;
            if (this.SModelNewsCoverageList.filter(c => c.state != this.Global.SModel.Delete && c.newsCoverageID == this.NewsCoverageform.id).length > 0) {
              this.isdisabled = true;
              this.NewsCoverageForm = this.SModelNewsCoverageList.filter(c => c.state != this.Global.SModel.Delete && c.newsCoverageID == this.NewsCoverageform.id)[0];
            } else {
              this.isdisabled = false;
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.mediaitem {
  width: 12%;
  height: 28%;
  border-radius: 10%;
  overflow: hidden;
  margin: calc(100vw * 5 / 1920) calc(100vw * 15 / 1920);
  // background-color: rgb(230, 98, 98);
  transform: scale(1);
  transition: all 0.6s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mediaitem:hover {
  transform: scale(1.2);
}
.hand {
  cursor: pointer;
  width: 100%;
  height: 100%;
}
</style>